import {Point} from '@mintdata/mint-kit/api/models/Point';
import {Size} from '@mintdata/mint-kit/api/models/Size';

export class Bounds
{
    constructor(public x:number,
                public y:number,
                public width:number,
                public height:number)
    {
    }

    public static newZero():Bounds
    {
        return new Bounds(0, 0, 0, 0);
    }

    public getTopLeft():Point
    {
        return Point.from(this.x, this.y);
    }

    public getSize():Size
    {
        return Size.from(this.width, this.height);
    }

    public toClientRect():ClientRect
    {
        return {
            left: this.x,
            right: this.x + this.width,
            top: this.y,
            bottom: this.y + this.height,
            width: this.width,
            height: this.height
        };
    }

    public isEqualTo(other:Bounds):boolean
    {
        return this.x === other.x &&
            this.y === other.y &&
            this.width === other.width &&
            this.height === other.height;
    }

    public static from(x:number, y:number, width:number, height:number):Bounds
    {
        return new Bounds(x, y, width, height);
    }

    public static intersect(first:Bounds, second:Bounds):Bounds
    {
        const firstRect = first.toClientRect();
        const secondRect = second.toClientRect();

        const lX1 = Math.min(firstRect.left, firstRect.right);
        const lY1 = Math.min(firstRect.top, firstRect.bottom);
        const lX2 = Math.max(firstRect.left, firstRect.right);
        const lY2 = Math.max(firstRect.top, firstRect.bottom);

        const rX1 = Math.min(secondRect.left, secondRect.right);
        const rY1 = Math.min(secondRect.top, secondRect.bottom);
        const rX2 = Math.max(secondRect.left, secondRect.right);
        const rY2 = Math.max(secondRect.top, secondRect.bottom);

        const x1 = Math.max(lX1, rX1);
        const x2 = Math.min(lX2, rX2);
        const y1 = Math.max(lY1, rY1);
        const y2 = Math.min(lY2, rY2);

        if( x2 >= x1 && y2 >= y1 )
        {
            return Bounds.from(x1, y1, x2 - x1, y2 - y1);
        }

        return Bounds.newZero();
    }

    toString()
    {
        return `(${this.x},${this.y}) -> (${this.width},${this.height})`;
    }
}
